export default {
  '--primary': '#8c2fdf',
  '--secondary': '#fbbf24',
  '--background': '#ffffff',
  '--text': '#111827',
  '--brand-green': '#299D6B',
  '--brand-green-dark': '#2A805A',
  '--brand-green-light': '#CBF0E0',
  '--brand-green-light-dark': '#299D6B',
  '--cream': '#FFFCF5',
  '--yellow-dark': '#A17805',
  'primary-text': '#101828',
}
